import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setLocale } from 'yup';
import _get from 'lodash/get';
import { resources } from 'src/i18n';
import { Box, IconButton, ListItemIcon, ListItemText, MenuItem, Popover, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const languageOptions = {
  en: {
    icon: '/static/icons/uk_flag.svg',
    label: 'English'
  },
  jp: {
    icon: '/static/icons/jp_flag.svg',
    label: 'Japanese'
  }
};

const LanguagePopover = (props) => {
  const { text } = props;
  const anchorRef = useRef(null);
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [lng, setLng] = useState(localStorage.getItem('language'));
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
    setLng(language);
    localStorage.setItem('language', language);
    setLocale(_get(resources[lng], 'translation.validation'));
    setOpen(false);
  };

  const selectedOption = languageOptions[i18n.language];

  return (
    <>
      <IconButton onClick={handleOpen} ref={anchorRef}>
        <Box
          sx={{
            display: 'flex',
            height: 20
            // width: 'auto',
            // '& img': {
            //   width: '100%'
            // }
          }}
        >
          <img alt={selectedOption.label} src={selectedOption.icon} />
        </Box>
        {text && (
          <Typography
            sx={{
              marginLeft: 1
            }}
            variant="p"
          >
            {text}
          </Typography>
        )}
      </IconButton>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom'
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 240 }
        }}
      >
        {Object.keys(languageOptions).map((language) => (
          <MenuItem onClick={() => handleChangeLanguage(language)} key={language}>
            <ListItemIcon>
              <Box
                sx={{
                  display: 'flex',
                  height: 20,
                  width: 30,
                  '& img': {
                    width: '30px'
                  }
                }}
              >
                <img alt={languageOptions[language].label} src={languageOptions[language].icon} />
              </Box>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography color="textPrimary" variant="subtitle2">
                  {languageOptions[language].label}
                </Typography>
              }
            />
          </MenuItem>
        ))}
      </Popover>
    </>
  );
};

LanguagePopover.propTypes = {
  text: PropTypes.string
};

export default LanguagePopover;
